<template>
  <section class="our-packages">
    <div class="container container--mw-xxl our-packages__container">
      <div class="row m-0 our-packages__row">
        <!--                <div class="col p-0 our-packages__column">-->
        <!--                    <PackagesBlock-->
        <!--                        :block-heading="'FREE'"-->
        <!--                        :list-heading="'To see how it works'"-->
        <!--                        :list-items="['Limited access to tools', 'Limited search for names', 'Limited access to availability insights']"-->
        <!--                        :price-description="'Free'"-->
        <!--                        :button-text="'GET STARTED NOW'"-->
        <!--                    />-->
        <!--                </div>-->

        <div class="col p-0 our-packages__column">
          <PackagesBlock
            :block-heading="'KHONSU SINGLE SESSION'"
            :list-heading="'For One-time brand creation'"
            :list-items="[
              'Free use of Khonsu Create',
              '5 Searches in Khonsu Check',
              'Save the results of one trademark search',
              'Get a free quote for how much it will cost to protect your trademark',
            ]"
            :price-description="'One time payment of £5 (Khonsu Introductory Offer only)'"
            :button-text="'SIGN UP FOR A SINGLE SESSION'"
            :button-link="'/join'"
          />
        </div>

        <div class="col p-0 our-packages__column">
          <PackagesBlock
            :block-heading="'KHONSU LIGHT'"
            :list-heading="'For Occasional brand creation'"
            :list-items="[
              'Free use of Khonsu Create',
              '15 searches in Khonsu Check',
              'Save the results of all searches',
              'Get a free quote for how much it will cost to protect your trademark',
            ]"
            :price-description="'£10 for 15 searches (Khonsu Introductory Offer only)'"
            :button-text="'SIGN UP FOR KHONSU LIGHT'"
            :button-link="'/join'"
          />
        </div>

        <div class="col p-0 our-packages__column">
          <PackagesBlock
            :block-heading="'KHONSU UNLIMITED'"
            :list-heading="'For Frequent brand creation'"
            :list-items="[
              'Free use of Khonsu Create',
              'Unlimited monthly searches in Khonsu Check',
              'Save unlimited search results',
              'Free quotes for how much it will cost to protect your trademark',
            ]"
            :price-description="'Contact us for an introductory price'"
            :button-text="'SIGN UP FOR UNLIMITED'"
            :button-link="'/join'"
          />
        </div>
      </div>
    </div>

    <div class="container">
      <p
        class="body-copy body-copy--fw-700 body-copy--align-center our-packages__bottom-copy"
      >
        To change or upgrade your current plan
        <router-link
          to="/my-account/manage-plan/top-up"
          class="our-packages__upgrade-link"
          >click here</router-link
        >
      </p>
    </div>
  </section>
</template>

<script>
import PackagesBlock from "@/views/OurPackages/PackagesBlock";

export default {
  name: "PackagesSection",
  components: {
    PackagesBlock,
  },
};
</script>
